export default __webpack_public_path__ + "static/media/nft-logo-white.3b9ebeb7.svg";